import(/* webpackMode: "eager", webpackExports: ["ModulesPageContent"] */ "/app/components/frontend/modules/modules-page-content.tsx");
